import React, { useEffect, useRef } from "react";

const Dropdown = ({ align = "left", isOpen, onClose, className = "", children }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target) && onClose) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const alignmentClass = align === "right" ? "right-0" : "left-0";
  const classes = [
    "absolute z-50 mt-2 w-56 rounded-md border border-gray-200 bg-white py-1 shadow-lg dark:border-gray-700 dark:bg-gray-800",
    alignmentClass,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div ref={ref} className={classes} role="menu">
      {children}
    </div>
  );
};

const DropdownItem = ({ tag = "button", className = "", children, ...props }) => {
  const Comp = tag;
  const classes = [
    "flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-700",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  if (Comp === "button") {
    return (
      <button type="button" className={classes} {...props}>
        {children}
      </button>
    );
  }

  return (
    <Comp className={classes} {...props}>
      {children}
    </Comp>
  );
};

export { Dropdown, DropdownItem };
